var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SummaryTile',{attrs:{"title":"Specimena"}},[_vm._v("\n    "+_vm._s(_vm.numberOfSpecimena)+"\n    "),_c('v-icon',[_vm._v("filter_vintage")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }